
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post71() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi pessoal. Estou com glicose em jejum de 151 tomando glifage 1x ao dia. É muito ruim?
A médica havia me receitado 2x ao dia, mas eu estava muito ruim com os primeiros sintomas, e diminui para 1x pela manhã.
Obrigado!</title>
        <meta 
          name="description" 
          content="Oi pessoal. Estou com glicose em jejum de 151 tomando glifage 1x ao dia. É muito ruim?
A médica havia me receitado 2x ao dia, mas eu estava muito ruim com os primeiros sintomas, e diminui para 1x pela manhã.
Obrigado!"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Caroline Pereira &#183; 11/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi pessoal. Estou com glicose em jejum de 151 tomando glifage 1x ao dia. É muito ruim?<br/>A médica havia me receitado 2x ao dia, mas eu estava muito ruim com os primeiros sintomas, e diminui para 1x pela manhã.<br/>Obrigado!
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/71')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  1 pessoa achou útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi Caroline!<br/><br/>Entendo a sua preocupação. Seu nível de glicose em jejum de 151 mg/dL está acima do ideal, e isso pode sim ser um sinal de que o diabetes não está bem controlado.<br/><br/>É muito importante seguir as recomendações da sua médica. Ajustar o medicamento por conta própria pode não ser seguro e pode fazer com que o tratamento não seja tão eficaz. Essas alterações podem estar causando o aumento da sua glicose.<br/><br/>Recomendo que você entre em contato com a sua médica o mais rápido possível para explicar a situação e os sintomas que você sentiu ao tomar o remédio duas vezes ao dia. Ela pode ajustar a dosagem ou trocar o medicamento para algo que você tolere melhor.<br/><br/>Enquanto isso, tente manter uma alimentação equilibrada, evitar alimentos ricos em açúcar e fazer atividades físicas regularmente, se possível. Essas atitudes podem ajudar a controlar melhor o seu nível de glicose.<br/><br/>Cuide-se bem e boa sorte na consulta! Se precisar de mais alguma coisa, estou aqui para ajudar.<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 11/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/71')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Elisa Orta &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/36-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde pessoal,<br/><br/>Vocês que tem hipertensão primária, fizeram exames pra investigar? Quais?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/36')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Leonardo Silveira &#183; 18/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/2-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Os benefícios para saúde de ter um Border Collie  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Há anos atrás, quando estava na faculdade, eu costumava correr na rua em algum parque 2 ou 3 vezes na semana, por cerca de 30 minutos. Com o tempo, e conforme fui ficando mais ocupado, acabei deixando esse bom hábito de lado. E uma vez que o hábito de exercício físico normalmente traz consigo outros hábitos, como de uma alimentação mais saudável e menos bebida alcoólica, esses também foram se deteriorando com o tempo. Consequentemente, ao longo dos anos sutilmente resultados disso foram surgindo, como aumento de peso e menor disposição.<br/><br/>Dois anos atrás, porém, decidi junto com minha esposa adotar um cachorro, e escolhemos uma Border Collie. A nova integrante da família, conforme nós esperávamos, nos forçou a uma série de mudanças na rotina. Eu fiquei responsável pelos passeios duas vezes por dia: às 6 da manhã, antes do trabalho, e no final da tarde. Isso me forçou diretamente e sem rodeios a iniciar uma atividade física disfarçada, que foram as caminhadas com nossa cachorra, que foram aumentando de duração e intensidade conforme ele crescia.<br/><br/>A raça Border Collie é conhecida por ser a raça mais inteligente, e também de alta energia. E sem dúvida existe alguma verdade nessa afirmação. As caminhadas deixaram de ser o bastante para a nossa cachorra, e para conseguir gastar sua energia e mantê-la saudável treinamos ela para jogar frisbee: pegar o disco no ar após jogarmos e traze-lo novamente para nós, em um ciclo aparentemente infinito de arremessos. Ela aprendeu rapidamente o esporte e se tornou um dos melhores cachorros que já vimos pegando o disco no ar em saltos acrobáticas.<br/> <br/>Porém, as caminhadas intensas duas vezes por dia com ela me fez lembrar de como eu me sentia bem após uma corrida intensa na época da faculdade, e como estava disposto no dia seguinte para o estudo e trabalho. Com isso, comecei aos poucos a correr junto de minha cachorra na rua. Essa corrida foi aumentando, primeiro somente a tarde alguns dias, depois mais alguns dias de manhã, e por fim, hoje corro com ela todos os dias de manhã e a tarde.<br/><br/>Isso mantém minha cachorra feliz e nós dois saudáveis, além de me manter disposto e com mais energia do que me sentia em anos. E hoje nem penso em não fazer isso, simplesmente porque sei como me sinto e vejo como ela fica feliz na horário dos nossos passeios. Esse são alguns, dos muitos benefícios de ter um Border Collie (ou qualquer outro cachorro) como companheiro.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/2')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Rita Anton &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/96-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Bom dia. Será que açúcar demerara quem tem diabetes pode usar?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/96')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            8 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Jussara Melo &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/38-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde pessoal<br/>Mais alguém aqui tem zumbido no ouvido?<br/>Minha pressão fica ao redor 15 por 10 mesmo tomando Losartana e hidroclorotiazida<br/>Oque vcs acham? Pode ser por isso?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/38')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marcela Prattes &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/104-colesterol" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Alguma dica de algo natural para baixar triglicerídeos?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/104')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
